$(document).ready(function () {
    window.enviarFormulario = function () {
        $(".loader_").addClass("loading")
        $("#books-info").html('')
        var formData = new FormData(document.getElementById('form-upload-file'));
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/admin/upload-items', true);
        xhr.onreadystatechange = function () {
            if (xhr.responseText.trim() !== "") {
                let response = JSON.parse(xhr.responseText);
                if (response.success === "success") {
                    $(".loader_").removeClass("loading")
                    $("#books-info").html(response.errores)
                    $("#books-info-actualizados").html(response.actualizados)
                    var input = document.getElementById('buttonFile');
                    input.value = '';
                    alertSuccessWithBtn(response.msg)
                }else{
                    alertErrorAlmadia(response.msg)
                }
            }
        };
        xhr.send(formData);
    }
})
